import axiosDonation from "./axiosDonation";
import axios from "axios";

import axiosAuth from "./axiosAuth";

import driverApi from "./driverApi";

const loginApi = {
  loginHydra: async (data: any) => {
    const rawUsername = (data.username || "").trim();
    const isPhoneNumber = /^[0-9+]{8,15}$/.test(rawUsername);

    // If username is a phone number -> Driver Login
    if (isPhoneNumber) {
      try {
        // Try real driver login endpoint first
        const driverRes = await driverApi.loginDriver({
          phone: rawUsername,
          password: data.password,
        });

        if (driverRes.data && (driverRes.data.code === 0 || driverRes.data.token || driverRes.data.data?.token)) {
          const respData = driverRes.data.data || driverRes.data;
          let token = respData.token || respData.accessToken;
          const driver = respData.driver || respData.user || {};
          const currentDriverId = driver.id || driver.driverId || "";

          localStorage.setItem("userRole", "driver");
          localStorage.setItem("driverId", currentDriverId);
          localStorage.setItem("driverName", driver.name || driver.driverName || "");
          localStorage.setItem("driverPhone", driver.phone || rawUsername);

          // In local development, if backend requires hydra JWT and does not support driver_ token directly,
          // fetch proxy token. On dev/staging/prod (production build), use server driver token directly.
          if (process.env.NODE_ENV === "development" && token && token.startsWith("driver_")) {
            try {
              const tokenRes = await axios.get(
                `/proxy-token/token?UserID=${currentDriverId}&template=templates/hydra.template&Roles=driver,user,admin`
              );
              if (tokenRes.data) {
                token = tokenRes.data;
              }
            } catch (e) {
              console.warn("Could not fetch proxy JWT for driver in local dev, using server token:", e);
            }
          }

          return { data: { code: 0, data: { token } } };
        }
      } catch (err) {
        // If driver login fails on dev local, fallback to local proxy token for testing
        if (process.env.NODE_ENV === "development") {
          if (rawUsername === "0987654321") {
            const driverId = "01M4CMQGHAWK235DJP5AMAGW5Z";
            localStorage.setItem("userRole", "driver");
            localStorage.setItem("driverId", driverId);
            localStorage.setItem("driverName", "Thanh Tùng");
            localStorage.setItem("driverPhone", "0987654321");
            const tokenRes = await axios.get(
              `/proxy-token/token?UserID=${driverId}&template=templates/hydra.template&Roles=driver,user,admin`
            );
            return { data: { code: 0, data: { token: tokenRes.data } } };
          }

          if (rawUsername === "0123456789") {
            const driverId = "01M4CMRCM79WPC2846SJHWRAZG";
            localStorage.setItem("userRole", "driver");
            localStorage.setItem("driverId", driverId);
            localStorage.setItem("driverName", "Hữu Nghị");
            localStorage.setItem("driverPhone", "0123456789");
            const tokenRes = await axios.get(
              `/proxy-token/token?UserID=${driverId}&template=templates/hydra.template&Roles=driver,user,admin`
            );
            return { data: { code: 0, data: { token: tokenRes.data } } };
          }
        }
        throw err;
      }
    }

    // Admin / Email Login
    if (process.env.NODE_ENV === "development") {
      // Local testing backdoor for admin
      if (data.password === "123456789") {
        localStorage.setItem("userRole", "admin");
        const tokenRes = await axios.get(
          "/proxy-token/token?UserID=01G4866BBJGYR1JH8E6RPYEW2C&template=templates/hydra.template&Roles=admin,user"
        );
        return { data: { code: 0, data: { token: tokenRes.data } } };
      }
      return axiosAuth.post("/hydra/auth/login-username-password", data);
    }

    localStorage.setItem("userRole", "admin");
    return axiosDonation.post("/hydra/auth/login-username-password", data);
  },

  getCurrentProfile: () => {
    if (process.env.NODE_ENV === 'development') {
      const token = localStorage.getItem("tokenRESHARE") || sessionStorage.getItem("tokenRESHARE") || "";
      return axios.post("/proxy-hydra/hydra/user/get-current-profile", null, {
        headers: { Authorization: `Bearer ${token}` }
      });
    }
    return axiosDonation.post("/hydra/user/get-current-profile", null);
  },
};

export default loginApi;
